<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Dr Merja Sankelo is a Finnish author who has a long scientific background in health research. She has been interested in spiritual-growth- and healing-related issues for many years. She decided to visit the famous spiritual healing centre Casa de Dom Inácio in Brazil and carried out a qualitative research focused on the experiences of visitors in Casa. The results are reported in this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c1fe488a